import { createAction } from "@reduxjs/toolkit";

export namespace SidebarActions {
  export enum ActionTypes {
    open = "Sidebar: open",
    close = "Sidebar: close",
    toggle = "Sidebar: toggle",
  }

  // Actions Types
  export const openSidebar = createAction(ActionTypes.open);
  export const closeSidebar = createAction(ActionTypes.close);
  export const toggleSidebar = createAction(ActionTypes.toggle);

  export type OpenSidebar = ReturnType<typeof openSidebar>;
  export type CloseSidebar = ReturnType<typeof closeSidebar>;
  export type ToggleSidebar = ReturnType<typeof toggleSidebar>;

  export type Actions = OpenSidebar | CloseSidebar | ToggleSidebar;
}
